export const formatFileSize = (sizeInBytes: number): string => {
  if (sizeInBytes >= 1_073_741_824) {
    // 1024 * 1024 * 1024
    return `${(sizeInBytes / 1_073_741_824).toFixed(1)} GB`;
  }

  if (sizeInBytes >= 1_048_576) {
    // 1024 * 1024
    return `${(sizeInBytes / 1_048_576).toFixed(1)} MB`;
  }

  if (sizeInBytes >= 1024) {
    return `${(sizeInBytes / 1024).toFixed(1)} KB`;
  }

  return `${sizeInBytes} bytes`;
};

export const formatFileType = (type?: string): string => {
  if (!type) return 'FILE';
  const t = type.toLowerCase().trim();

  const MAP: Record<string, string> = {
    'application/pdf': 'PDF',

    // Word
    'application/msword': 'DOC',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'DOCX',

    // Excel
    'application/vnd.ms-excel': 'XLS',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'XLSX',
    'text/csv': 'CSV',

    // PowerPoint
    'application/vnd.ms-powerpoint': 'PPT',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'PPTX',

    // Images
    'image/png': 'PNG',
    'image/jpeg': 'JPG',
    'image/jpg': 'JPG',
    'image/gif': 'GIF',
    'image/webp': 'WEBP',
    'image/svg+xml': 'SVG',
    'image/heic': 'HEIC',

    // Text / code
    'text/plain': 'TXT',
    'application/json': 'JSON',
    'application/xml': 'XML',

    // Archives
    'application/zip': 'ZIP',
    'application/x-zip-compressed': 'ZIP',
    'application/x-7z-compressed': '7Z',
    'application/x-rar-compressed': 'RAR',
    'application/x-tar': 'TAR',

    // Media
    'audio/mpeg': 'MP3',
    'video/mp4': 'MP4',

    // Generic binary
    'application/octet-stream': 'BIN',
  };

  if (MAP[t]) return MAP[t];

  const slashIdx = t.indexOf('/');
  if (slashIdx === -1) return 'FILE';
  let sub = t.slice(slashIdx + 1);
  sub = sub.replace(/^vnd\./, '').replace(/^x-/, '');
  if (sub.includes('+')) sub = sub.split('+')[0];
  if (sub.includes('.')) sub = sub.split('.').pop() || sub;
  return sub.toUpperCase() || 'FILE';
};
